import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

export const PrivateRouter = ({ children }) => {
  const { status } = useSelector((state) => state.auth);
  return status ? children : <Navigate to="/" />;
};

PrivateRouter.propTypes = {
  children: PropTypes.element,
};
